import { render, staticRenderFns } from "./quick-message.vue?vue&type=template&id=042f517d"
import script from "./quick-message.vue?vue&type=script&lang=js"
export * from "./quick-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('042f517d')) {
      api.createRecord('042f517d', component.options)
    } else {
      api.reload('042f517d', component.options)
    }
    module.hot.accept("./quick-message.vue?vue&type=template&id=042f517d", function () {
      api.rerender('042f517d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/quick-message/quick-message.vue"
export default component.exports